import imageUrl1 from '../../../Assets/blogs/washers.webp';

const post = {
    id: 'klean-leaf-expansion',
    title: 'Klean Leaf Expands Laundry Detergent Sheet Production Support',
    date: 'February 1, 2024',
    summary: 'Klean Leaf expanded production support for laundry detergent sheets, helping private label buyers plan sampling, packaging, production, and logistics.',
    metaTags: {
        description: "Klean Leaf expanded laundry detergent sheet production support for private label buyers, including sampling, packaging, manufacturing coordination, and logistics.",
        keywords: "klean leaf, laundry detergent sheets, laundry sheets manufacturer, powerful clean",
        author: "Klean Leaf",
    },
    content: `<p>Klean Leaf has expanded support for private label laundry detergent sheet programs, giving business buyers more guidance around sampling, packaging, production planning, and logistics coordination.</p>
    <p>Our Columbus, Ohio team works with brands, refill shops, wholesalers, retailers, and distributors that need a practical path from product idea to finished laundry sheet order.</p>
    <p>This support can include formula and scent discussion, packaging format review, artwork requirements, MOQ planning, available documentation, and shipment coordination.</p>
    <p>Laundry detergent sheets remain a strong format for buyers looking for a compact, lightweight alternative to traditional liquid detergent products. They are easier to store, easier to ship, and compatible with retail, refill, wholesale, and e-commerce programs.</p>
    <p>As demand grows, Klean Leaf will continue improving the systems that help buyers evaluate samples, confirm packaging, plan production, and bring private label laundry sheet products to market.</p>
    `,
    imageUrl1: imageUrl1,
};

export default post;
